<template>
	<div class="case-container" v-loading="loading">
		<div class="box7 mainCont">
			<div class="list">
				<div class="item" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
					<img class="img" :src="item.img" alt="1">
					<h4>{{item.title}}</h4>
				</div>
			</div>
		</div>
		
		<el-empty v-if="!loading&&list.length==0" description="暂无服务项目"></el-empty>
		
		<div class="pageBox">
			<el-pagination background layout="prev, pager, next" :page-size="pageSize" :hide-on-single-page="true" :total="total" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>
<script >
	
import {getFwalList} from '@/api/api'
export default {
	name: 'home2',
	data() {
		return {
			
			list:[],
			pageIndex:1,
			pageSize:10,
			total:0,
			loading:true,
		};
	},
	mounted() {
		this.getProductList();
	},
	methods: {
		
		getProductList(){
			this.loading = true;
			let pageIndex = this.pageIndex;
			getFwalList({pageIndex,pageSize:this.pageSize,}).then(res => {
				let list = res.data;
				this.total = res.total;
				this.list = list;
				this.loading = false;
			})
		},
		// 分页
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getProductList();
		},
		goDetail(item){
			this.$router.push({
			path: '/case/detail',
				query: {
					id: item.id
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.case-container{background-color: #F5F8F9;padding-top:24px;
	.box7{
		.list{display: flex;align-items: center;
			.item{width: 285px;height: 285px;background: #FFFFFF;border-radius: 8px;overflow: hidden;position: relative;margin-right: 20px;margin-bottom: 20px;
				&:last-child{margin-right: 0;}
				.img{width: 100%;height: 100%;transition: all .3s;}
				h4{position: absolute;left: 0;right: 0;bottom: 0;line-height: 40px;text-align: center;color: #FFFFFF;font-size: 14px;height: 40px;background: rgba(0,0,0,0.5);border-radius: 0px 0px 8px 8px;}
				&:hover{
					.img{transform: scale(1.2);}
					h4{color: #2F78FF;}
				}
			}
		}
	}
	

	.pageBox{display: flex;align-items: center;justify-content: space-around;margin-bottom: 30px;}
}
</style>


// WEBPACK FOOTER //
// src/views/case/index.vue